import router from "@/router/index.js";

export const executeApiCall = async (path, params, ignoreToken) => {
    let host = 'https://localhost/';
    if (window.location.host === 'tadfitnessclub.com') {
        host = 'https://api.tadfitnessclub.com/'
    }
    const url = `${host}${path}`;

    if (!params) {
        params = {};
    }

    if (!ignoreToken) {
        params.authToken = localStorage.getItem("token");
    }

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }

        const json = await response.json();
        return JSON.parse(json);
    } catch (error) {
        return null;
    }
}

export const isValidJwt = (jwt) => {
    if (!jwt || jwt.split('.').length < 3) {
        return false
    }
    const data = JSON.parse(atob(jwt.split('.')[1]));
    const exp = new Date(data.exp * 1000);
    const now = new Date();

    return now < exp
};

export const checkSession = async () => {
    if (isLogged()) {
        return true;
    } else {
        sessionStorage.removeItem("token");
        await router.push({name: 'login'});
    }
};

export const isLogged = () => {
    const token = localStorage.getItem("token");
    return isValidJwt(token);
};

export const redirectIfLogger = async () => {
    if (isLogged()) {
        await router.push({name: 'meniuri'});
    }
};

export const getUrlParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const params = {};

    for (const [key, value] of urlParams) {
        params[key] = value;
    }

    return params;
};

export const formatDate = (dateString) => {
    if (dateString) {
        return  new Date(dateString).toLocaleDateString('ro-RO', { year: 'numeric', month: 'long', day: 'numeric' });
    }

    return '-';
};

export const login = async (res) => {
    const parsed = JSON.parse(res.message);
    const token = parsed.token;
    const name = parsed.name;
    const email = parsed.email;
    const avatar = parsed.avatar;
    const expired = parsed.expired;
    const isAdmin = parsed.is_admin;
    const cash = parsed.cash;
    const family = parsed.family;

    isValidJwt(token);
    localStorage.setItem("token", token);
    localStorage.setItem("name", name);
    localStorage.setItem("email", email);
    localStorage.setItem("avatar", avatar);
    localStorage.setItem("expired", expired);
    localStorage.setItem("isAdmin", isAdmin);
    localStorage.setItem("cash", cash);
    localStorage.setItem("family", family);
    await router.push({name: 'meniuri'});
};
